import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const LogoutTimer = ({ logoutCallback }) => {
  const [isActive, setIsActive] = useState(true);
  const history = useNavigate();

  useEffect(() => {
    let idleTimer;
    let sessionTimer;

    const resetActivity = () => {
      
      //setIsActive(true);
      //clearTimeout(idleTimer);
      //clearTimeout(sessionTimer);
      //idleTimer = setTimeout(handleIdle, 4 * 60 * 1000);
      //sessionTimer = setTimeout(logoutCallback, 15 * 60 * 1000);
    };

    const handleIdle = () => {
      setIsActive(false);
      console.log("Logging the user out due to inactivity");
      logoutCallback();
    };

    const handleSessionTimeout = () => {
      console.log("Logging the user out due to session timeout");
      logoutCallback();
    };

    document.addEventListener('mousemove', resetActivity);
    document.addEventListener('keypress', resetActivity);

    //idleTimer = setTimeout(handleIdle, 4 * 60 * 1000);
    //sessionTimer = setTimeout(handleSessionTimeout, 15 * 60 * 1000);

    return () => {
      clearTimeout(idleTimer);
      clearTimeout(sessionTimer);
      document.removeEventListener('mousemove', resetActivity);
      document.removeEventListener('keypress', resetActivity);
    };
  }, [logoutCallback, history]);

  return <div>{isActive ? '' : ''}</div>;
};

export default LogoutTimer;
